import { parseAbi } from "viem";

export const minterAbi = parseAbi([
  "function redeem((uint256 tokenId,address recipient,uint8 tier,uint256 price,uint256 nonce,uint256 deadline,uint256 pricingVersion,bytes32 resolverHash) voucher, string resolver, bytes signature) payable"
]);

export const registryAbi = parseAbi([
  "function setController(uint256 tokenId, address newController)",
  "function setResolver(uint256 tokenId, string newResolver)",
  "function safeTransferFrom(address from, address to, uint256 tokenId)"
]);
